import { Component } from 'react';

export class MultipleUsersSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                data-testid="multiple-users-icon"
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.00008 9.25001C11.2232 9.25001 12.3343 10.6389 12.3334 13.4167C12.3334 14.5278 11.7779 15.0833 10.6667 15.0833H2.33341C1.2223 15.0833 0.666748 14.5278 0.666748 13.4167C0.666748 10.6389 1.7789 9.25001 4.00319 9.25001H9.00008ZM14.0001 9.25001C16.2232 9.25001 17.3343 10.6389 17.3334 13.4167C17.3334 14.5278 16.7779 15.0833 15.6667 15.0833H13.1799C13.7267 15.0833 14.0001 14.25 14.0001 12.5833C14.0001 11.1489 13.4445 10.0378 12.3334 9.25001H14.0001ZM9.00008 10.9167H4.00319C2.93453 10.9167 2.37883 11.6847 2.33609 13.2207L2.33341 13.4167H10.6667C10.6667 11.75 10.1112 10.9167 9.00008 10.9167ZM13.5834 3.41667C14.7339 3.41667 15.6667 4.34948 15.6667 5.50001C15.6667 6.65053 14.7339 7.58334 13.5834 7.58334C12.4329 7.58334 11.5001 6.65053 11.5001 5.50001C11.5001 4.34948 12.4329 3.41667 13.5834 3.41667ZM6.50008 0.916672C8.34092 0.916672 9.83342 2.40917 9.83342 4.25001C9.83342 6.09084 8.34092 7.58334 6.50008 7.58334C4.65925 7.58334 3.16675 6.09084 3.16675 4.25001C3.16675 2.40917 4.65925 0.916672 6.50008 0.916672ZM6.50008 2.58334C5.57966 2.58334 4.83342 3.32959 4.83342 4.25001C4.83342 5.17042 5.57966 5.91667 6.50008 5.91667C7.4205 5.91667 8.16675 5.17042 8.16675 4.25001C8.16675 3.32959 7.4205 2.58334 6.50008 2.58334Z"
                    fill="#08172B"
                />
            </svg>
        );
    }
}
